import { useEffect, useState } from "react";
import { program } from "@/api";
import { Eye } from "lucide-react";

/**
 * Lee y cachea por sesión el estado `supplier_readonly_mode` del programa.
 * Devuelve { enabled, loading } — true significa que el proveedor está en Fase 1
 * (modo Visor) y la UI debe ocultar/deshabilitar acciones de escritura.
 */
export function useSupplierReadonly() {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    program
      .supplierReadonly()
      .then((r) => setEnabled(Boolean(r.enabled)))
      .catch(() => setEnabled(true)); // safe default = readonly
  }, []);
  return { enabled, loading: enabled === null };
}

/**
 * Banner reusable para páginas del proveedor cuando el modo Visor está activo.
 */
export function ReadonlyBanner({ action = "esta acción", className = "" }) {
  return (
    <div
      data-testid="readonly-banner"
      className={`sketch-border-soft bg-[var(--lala-blue-soft)] border-[var(--lala-blue)] p-4 mb-4 flex items-start gap-3 ${className}`}
      style={{ boxShadow: "3px 4px 0 0 #0033AD" }}
    >
      <Eye size={20} className="text-[var(--lala-blue)] mt-0.5 flex-shrink-0" />
      <div className="text-sm">
        <div className="font-bold text-[var(--lala-blue)] uppercase tracking-wider text-[11px]">
          Modo Visor · Fase 1
        </div>
        <div className="text-[var(--ink)] mt-0.5 leading-relaxed">
          Estás viendo tu información en modo lectura. Lala alimenta tus documentos,
          evaluaciones y cuestionarios directamente para evitar que seas{" "}
          <strong>juez y parte</strong>. <em>{action}</em> se habilitará en Fase 2.
        </div>
        <div className="text-[var(--ink-soft)] text-xs mt-1">
          ¿Necesitas reportar algo? Contacta a tu comprador Lala.
        </div>
      </div>
    </div>
  );
}
